import {
  Box,
  Button,
  TextField,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Header from "../../../../components/Header";

import Swal from "sweetalert2";
import { executeDynamicSubmit } from "../../../../data/DynamicServiceNew/jsondynamicservice";
import { setupManagementUrl } from "../../../../config";

const setup_url = setupManagementUrl.uri;

const CollateralConditionForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const initialValues = {
    name: props.data ? props.data.Condition : "",
  };

  const validationSchema = yup.object().shape({
    name: yup.string().required("Condition required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const { name } = values;
    const variables = props.isEditing
      ? { id: props.data.Id, condition: name }
      : { condition: name };

    await executeDynamicSubmit({
      mutationName: props.isEditing ? "updateCollateralCondition" : "createCollateralConditions",
      variables,
      mutationObjectName: "result",
      baseUrl: setup_url,
      isEditing: props.isEditing,
      entityName: "Collateral Condition",
      onSuccess: () => {
        props.onClose();
        props.onAction();
      },
      setSubmitting,
    });
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Collateral Condition" : "Create Collateral Condition"}
        subtitle={
          props.isEditing
            ? "Edit an Existing Collateral Condition"
            : "Create a New Collateral Condition"
        }
      />
      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Collateral Condition *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
                name="name"
                error={touched.name && !!errors.name}
                helperText={touched.name && errors.name}
                sx={{ gridColumn: "span 2" }}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default CollateralConditionForm;
